import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? "");

  return (
    <section
      id="faq"
      className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50 scroll-mt-24"
    >
      <SectionHeading
        eyebrow="常见问题"
        title="吃瓜之前，你可能想先了解这些"
        desc="关于更新频率、内容可信度和投稿方式，这里统一说明。"
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
        <div className="lg:col-span-2">
          <div className="rounded-lg border border-background-200 overflow-hidden bg-background-100">
            {faqs.map((faq, index) => {
              const isOpen = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={index > 0 ? "border-t border-background-200" : ""}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? "" : faq.id)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-200/60 transition-colors"
                    >
                      <span className="flex items-center gap-3 text-sm md:text-base font-medium text-foreground-900">
                        <span className="text-primary-500 font-bold">
                          Q{index + 1}
                        </span>
                        {faq.question}
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-400 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-4 md:px-6 pb-5 -mt-1">
                      <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="rounded-lg bg-primary-50 border border-primary-100 p-6 h-fit">
          <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center mb-4">
            <i className="ri-question-answer-line text-xl" aria-hidden="true"></i>
          </span>
          <h3 className="text-lg font-bold text-foreground-950">
            还有别的问题？
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
            关于内容、投稿或合作，都可以直接联系我们，通常会在一个工作日内回复。
          </p>
          <Link
            to="/about"
            className="mt-5 inline-flex items-center gap-1 h-10 px-4 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-customer-service-2-line" aria-hidden="true"></i>
            去关于我们看看
          </Link>
        </div>
      </div>
    </section>
  );
}